export default {
  0: 'secondary2',
  1: 'info',
  2: 'success',
  3: 'error',
  4: 'deep-purple',
  5: 'brown'
}